import React, { useEffect } from 'react';
import { useCopyToClipboard } from 'usehooks-ts';
import { openSuccessToaster } from 'services/toast.service';
import styles from './BagelChatWidget.module.scss';

interface BagelQuoteBlockProps {
  children: string;
}

/**
 * BagelQuoteBlock — renders a ```quote fence as a copyable message/callout card.
 */
export default function BagelQuoteBlock({
  children,
}: BagelQuoteBlockProps) {
  const text = children.trim();
  const [copiedText, copy] = useCopyToClipboard();

  useEffect(() => {
    if (copiedText) {
      openSuccessToaster('Copied to clipboard.', 2000);
    }
  }, [copiedText]);

  return (
    <blockquote className={styles.quoteBlock}>
      <div className={styles.quoteBlockBody}>
        <p className={styles.quoteBlockText}>{text}</p>
      </div>
      <button
        type="button"
        className={styles.quoteBlockCopyBtn}
        onClick={() => copy(text)}
        aria-label="Copy message"
      >
        Copy
      </button>
    </blockquote>
  );
}
